/**
 * **L'état de chargement, par squelette et non par tourniquet.**
 *
 * `web/CLAUDE.md` : « toute page qui affiche de la donnée serveur traite **les trois
 * états** : chargement par **squelette**, erreur avec réessai, et vide avec un message
 * utile. **Une page qui n'en traite qu'un est inachevée.** »
 *
 * Le squelette occupe la place que la donnée prendra, ce qu'un tourniquet ne fait pas :
 * la page ne saute pas quand la donnée arrive.
 */
type Props = {
  /** Combien de lignes, pour occuper la hauteur que la liste prendra. */
  readonly lignes?: number;
};

export function Squelette({ lignes = 3 }: Props) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="flex flex-col gap-2"
    >
      <span className="sr-only">Chargement…</span>
      {Array.from({ length: lignes }, (_, rang) => (
        <div
          key={rang}
          className="h-cible w-full animate-pulse rounded-2 bg-fond-bloc"
        />
      ))}
    </div>
  );
}
